/**
 * The legal pages' inline styles, as data.
 *
 * Extracted from `LegalPageLayout.jsx` so that the two things which render a
 * legal page — the React layout and `scripts/build-static-pages.mjs`, which
 * writes the static document a crawler receives — style it from ONE definition.
 *
 * The alternative was a static document carrying a second, hand-copied set of
 * inline styles, drifting from the component the moment either changed. These
 * pages are the Terms, the Privacy Policy and the Cookie Policy; a static
 * version that renders as unstyled text is not a smaller problem here than
 * elsewhere.
 *
 * Plain values only — no functions, no nesting. `styleAttr` in the generator
 * turns them into a `style="..."` attribute the same way React does, and
 * asserts anything it does not understand rather than guessing.
 */

const legalStyles = {
  pageWrapper: {
    position: "relative",
    backgroundColor: "#fff",
    color: "#1a1a1a",
    minHeight: "100vh",
  },
  main: {
    backgroundColor: "#fff",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "120px 24px 80px",
  },
  header: {
    marginBottom: "48px",
    borderBottom: "1px solid #d5d0cb",
    paddingBottom: "32px",
  },
  title: {
    fontSize: "clamp(28px, 5vw, 40px)",
    fontWeight: 600,
    color: "#1a1a1a",
    margin: "0 0 16px 0",
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  date: {
    fontSize: "14px",
    color: "#888",
    margin: 0,
  },
  section: {
    marginBottom: "36px",
  },
  sectionHeading: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#1a1a1a",
    margin: "0 0 16px 0",
    lineHeight: 1.3,
    letterSpacing: "-0.01em",
  },
  paragraph: {
    fontSize: "15px",
    lineHeight: 1.75,
    color: "#444",
    margin: "0 0 14px 0",
  },
  emphasis: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1a1a1a",
    margin: "18px 0 8px 0",
    lineHeight: 1.4,
  },
  list: {
    fontSize: "15px",
    lineHeight: 1.75,
    color: "#444",
    margin: "0 0 14px 0",
    paddingLeft: "24px",
  },
  listItem: {
    marginBottom: "6px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    margin: "16px 0 20px 0",
    fontSize: "14px",
    overflowX: "auto",
    display: "block",
  },
  th: {
    textAlign: "left",
    padding: "10px 12px",
    borderBottom: "2px solid #d5d0cb",
    fontWeight: 600,
    color: "#1a1a1a",
    fontSize: "13px",
    letterSpacing: "0.03em",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "10px 12px",
    borderBottom: "1px solid #eee",
    color: "#555",
    lineHeight: 1.5,
    verticalAlign: "top",
  },
  intro: {
    fontSize: "15px",
    lineHeight: 1.8,
    color: "#555",
    margin: "0 0 40px 0",
    whiteSpace: "pre-line",
  },
};

export default legalStyles;
